import { Injectable } from '@angular/core';
import { Subject, debounceTime } from 'rxjs';
import { Filter } from '../models/filter';
import { IFilterModel } from '../models/filter-model';

export type FilterType = "DATE" | "FILTER"

export type FilterAction = "DELETE" | "SET" | "UPDATE" | "CLEAR" | "SEND"


export interface IFilterData {
	value: number | string;
	name: string;
}


export interface IFilterSubject {
  id : string;
	action: FilterAction;
	data: IFilterModel | null;
  array: IFilterModel[]
}

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  private _filters: IFilterModel[] = [];

  set filters(filters: IFilterModel) {
    console.log(this.filters);
    this._filters = this._filters.filter((filter) => filter.id != filters.id || filter.key != filters.key);
    this.filters.push(filters);
  }

  get filters(): IFilterModel[] {
    return this._filters;
  }

  filterSubject: Subject<IFilterSubject> = new Subject<IFilterSubject>();

  constructor() { }

  clear(groupId: string) {
    console.log(groupId);
    let filters = this.filters.filter((filter) => filter.id != groupId);
    this._filters = filters;
    console.log(this.filters);
    this.filterSubject.next({id: groupId, action: "CLEAR", data: null, array: filters});
  }

  send(filterModel: any) {
    console.log(filterModel);
    this.filters = filterModel;
    console.log(this.filters);
    this.filterSubject.next({id: filterModel.id, action: "SEND", data: filterModel, array: this.filters});
  }

  remove(filterModel: IFilterModel) {
    this._filters = this._filters.filter((filter) => {
      if (filter.id !== filterModel.id) return true;

      const isDateFilter = ['date', 'month'].includes(filterModel.key) || ['DATE', 'MONTH'].includes(filterModel.type);
      if (isDateFilter) {
        return !['date', 'month'].includes(filter.key) && !['DATE', 'MONTH'].includes(filter.type);
      }

      return filter.key !== filterModel.key;
    });

    this.filterSubject.next({id: filterModel.id, action: "DELETE", data: filterModel, array: this.filters});
  }

  /*set(id: string, field: string, key: string, type: FilterType, data: IFilterData[]) {
    let filter: IFilterModel;
		let filterIndex = this.filters.findIndex((filter) => filter.id == id);
		if(filterIndex != -1) {
			this.filters[filterIndex].data.push(...data)
      filter = this.filters[filterIndex];
		} else {
			filter = {
        id,
				key,
				type,
        field,
				data: data
			}
			this.filters.push(filter);
		}
		
		this.filterSubject.next({action: "SET", data: filter});
	}

  get(key: string) {
	  return this.filters.find((filter) => filter.key == key);
	}

  getAll() {
		return this.filters;
	}

  delete(id: string) {
		let filterIndex  = this.filters.findIndex((filter) => filter.id == id);
		if(filterIndex != -1) {
			this.filterSubject.next({action: "DELETE", data: this.filters[filterIndex]});
			this.filters.splice(filterIndex, 1);
		}
	}

  update(id: string, filter: IFilterModel) {
    let filterIndex = this.filters.findIndex((filter) => filter.id == id);
    if(filterIndex != -1) {
      this.filters[filterIndex] = filter;
    
      this.filterSubject.next({action: "UPDATE", data: filter});
    }
 }

 convertByFilterParams() {
  let filters = this.filters;
  let filterParam = new Filter();
  if(filters.length > 0) {
    for(let filter of filters) {
      for(let data of filter.data) {
        if(filter.type == "FILTER") {
          filterParam.filter(filter.field, data.value, "IN");
        } else {
          filterParam.date(filter.field, data.name, data.value as "after" | "before");
        }
      }
    }
  }
  
  return filterParam;
}*/
 
}
